import { CreditAccountComponent } from './credit-account.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    CurrencyFormatterPipe,
    TgButtons2Module,
    TgFormattersModule,
    TgGridModule,
    TgIconBasicMinusModule,
    TgIconBasicPlusModule,
    TgInputModule,
    TgLoadingModule,
    TgSpacingModule,
    TgValidationModule,
    TgValidatorsModule,
    TgSvgModule
} from '@trademe/tangram';
import { FormsModule } from '@angular/forms';
import { UserFacade } from '@classifieds-sell/state';
import {
    PingWidgetModule
} from '@classifieds-sell/trademe-core-ui';

@NgModule({
    declarations: [CreditAccountComponent],
    imports: [
        CommonModule,
        PingWidgetModule,
        FormsModule,
        TgButtons2Module,
        TgFormattersModule,
        TgGridModule,
        TgIconBasicPlusModule,
        TgIconBasicMinusModule,
        TgLoadingModule,
        TgInputModule,
        TgSpacingModule,
        TgSvgModule,
        TgValidationModule,
        TgValidatorsModule
    ],
    providers: [CurrencyFormatterPipe, UserFacade],
    exports: [CreditAccountComponent]
})
export class CreditAccountModule {}
